var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.e9c3450ae8c38c0e5a0741a3b03f6e0b.svg#bN';
                    var viewUrl = 'sprites.e9c3450ae8c38c0e5a0741a3b03f6e0b.svg#view-bN';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 32 29',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };